// QuestionEQ5D5L.js
import React from "react";
import { QuestionTextModel, QuestionFactory, Serializer } from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "eq5d5l";
let isRegistered = false;
// class QuestionEQ5D5LModel extends QuestionTextModel {
//   constructor(name) {
//     super(name);

//     // Set default properties for date input (same as date question)
//     this.inputType = "date";
//     this.placeholder = "";
//     this.autocomplete = "off";

//     // Set default date format
//     this.dateFormat = "yyyy-MM-dd";
//   }

//   getType() {
//     return QUESTION_TYPE;
//   }

//   // Custom properties (same as date)
//   get minDate() {
//     return this.getPropertyValue("minDate", "");
//   }

//   set minDate(val) {
//     this.setPropertyValue("minDate", val);
//   }

//   get maxDate() {
//     return this.getPropertyValue("maxDate", "");
//   }

//   set maxDate(val) {
//     this.setPropertyValue("maxDate", val);
//   }

//   get showTodayButton() {
//     return this.getPropertyValue("showTodayButton", false);
//   }

//   set showTodayButton(val) {
//     this.setPropertyValue("showTodayButton", val);
//   }

//   get dateFormat() {
//     return this.getPropertyValue("dateFormat", "yyyy-MM-dd");
//   }

//   set dateFormat(val) {
//     this.setPropertyValue("dateFormat", val);
//   }
// }

class QuestionEQ5D5LModel extends QuestionTextModel {
  constructor(name) {
    super(name);
    this.inputType = "date";
    this.autocomplete = "off";
    this.dateFormat = "yyyy-MM-dd";
  }

  getType() {
    return QUESTION_TYPE;
  }

  // ✅ NEW: only today enabled
  get onlyToday() {
    return this.getPropertyValue("onlyToday", false);
  }

  set onlyToday(val) {
    this.setPropertyValue("onlyToday", val);
  }

  get minDate() {
    return this.getPropertyValue("minDate", "");
  }

  set minDate(val) {
    this.setPropertyValue("minDate", val);
  }

  get maxDate() {
    return this.getPropertyValue("maxDate", "");
  }

  set maxDate(val) {
    this.setPropertyValue("maxDate", val);
  }
}

/* =========================================================
   REACT RENDERER - Same as date picker renderer
========================================================= */
class SurveyQuestionEQ5D5L extends SurveyQuestionElementBase {
  constructor(props) {
    super(props);
    this.inputRef = React.createRef();
  }

  get question() {
    return this.props.question;
  }

  handleChange = (e) => {
    this.question.value = e.target.value || null;
  };

  handleTodayClick = () => {
    const today = new Date();
    const formattedDate = today.toISOString().split("T")[0];
    this.question.value = formattedDate;
  };

  // renderDatePicker() {
  //   const q = this.question;
  //   const value = q.value ?? "";

  //   return (
  //     <div style={{ position: "relative" }}>
  //       <input
  //         ref={this.inputRef}
  //         type="date"
  //         id={q.id}
  //         name={q.name}
  //         value={value}
  //         onChange={this.handleChange}
  //         onBlur={q.onBlur?.bind(q)}
  //         onFocus={q.onFocus?.bind(q)}
  //         placeholder={q.placeholder}
  //         disabled={q.isReadOnly}
  //         required={q.isRequired}
  //         min={q.minDate}
  //         max={q.maxDate}
  //         style={{
  //           width: "100%",
  //           boxSizing: "border-box",
  //           padding: "8px 12px",
  //           paddingBottom: "30px",
  //           paddingRight: q.showTodayButton ? "80px" : "40px",
  //           borderRadius: "4px",
  //           border:
  //             q.errors.length > 0 ? "1px solid #dc3545" : "1px solid #ced4da",
  //           backgroundColor: q.isReadOnly ? "#e9ecef" : "#fff",
  //           fontSize: "16px",
  //           height: "38px",
  //           alignItems: "center",
  //         }}
  //       />

  //       {/* Today Button (optional) */}
  //       {q.showTodayButton && !q.isReadOnly && (
  //         <button
  //           type="button"
  //           onClick={this.handleTodayClick}
  //           style={{
  //             position: "absolute",
  //             right: "40px",
  //             top: "50%",
  //             transform: "translateY(-50%)",
  //             padding: "4px 8px",
  //             backgroundColor: "#007bff",
  //             color: "white",
  //             border: "none",
  //             borderRadius: "3px",
  //             fontSize: "12px",
  //             cursor: "pointer",
  //           }}
  //         >
  //           Today
  //         </button>
  //       )}
  //     </div>
  //   );
  // }

  renderDatePicker() {
    const q = this.question;
    const value = q.value ?? "";

    const today = new Date().toISOString().split("T")[0];

    const minDate = q.onlyToday ? today : q.minDate;
    const maxDate = q.onlyToday ? today : q.maxDate;

    return (
      <div style={{ position: "relative" }}>
        <input
          ref={this.inputRef}
          type="date"
          id={q.id}
          name={q.name}
          value={value}
          onChange={this.handleChange}
          disabled={q.isReadOnly}
          required={q.isRequired}
          min={minDate}
          max={maxDate}
          style={{
            width: "100%",
            padding: "8px 12px",
            borderRadius: "4px",
            border:
              q.errors.length > 0 ? "1px solid #dc3545" : "1px solid #ced4da",
            backgroundColor: q.isReadOnly ? "#e9ecef" : "#fff",
            fontSize: "16px",
            height: "38px",
          }}
        />
      </div>
    );
  }

  renderElement() {
    const q = this.question;

    return (
      <div style={{ position: "relative" }}>
        {/* Optional description */}
        {q.description && (
          <div
            style={{
              fontSize: "14px",
              color: "#6c757d",
              marginBottom: "8px",
              fontStyle: "italic",
            }}
          >
            {q.description}
          </div>
        )}

        {this.renderDatePicker()}

        {/* Selected date display */}
        {q.value && (
          <div
            style={{
              marginTop: "8px",
              padding: "8px",
              backgroundColor: "#e7f3ff",
              borderRadius: "4px",
              borderLeft: "4px solid #007bff",
              fontSize: "14px",
            }}
          >
            <strong>Selected Date:</strong> {q.value}
          </div>
        )}
      </div>
    );
  }
}

export function registerEQ5D5LQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  // Define custom properties (same as date picker)
  Serializer.addClass(
    QUESTION_TYPE,
    [
      // Inherit text properties
      {
        name: "title",
        category: "general",
        visible: true,
      },
      {
        name: "onlyToday:boolean",
        title: "Enable only today's date",
        category: "date",
        default: false,
        visible: true,
      },
      {
        name: "name:text",
        category: "general",
        visible: true,
        // ✅ Force text input type
        onSetValue: function (obj, value) {
          obj.name = value;
        },
      },
      {
        name: "description:text",
        category: "general",
        visible: true,
        default: "Select a date",
      },
      {
        name: "isRequired:boolean",
        category: "general",
        visible: true,
      },
      {
        name: "readOnly:boolean",
        category: "general",
        visible: true,
      },
      // Date-specific properties
      {
        name: "placeholder",
        category: "date",
        default: "Select Date",
        visible: true,
      },
      {
        name: "minDate",
        category: "date",
        visible: true,
      },
      {
        name: "maxDate",
        category: "date",
        visible: true,
      },
      {
        name: "showTodayButton:boolean",
        category: "date",
        default: false,
        visible: true,
      },
      {
        name: "dateFormat",
        category: "date",
        default: "yyyy-MM-dd",
        choices: [
          "yyyy-MM-dd",
          "dd/MM/yyyy",
          "MM/dd/yyyy",
          "dd-MM-yyyy",
          "MM-dd-yyyy",
        ],
        visible: true,
      },
    ],
    () => new QuestionEQ5D5LModel(""),
    "text", // Inherit from text question
  );

  // Hide unnecessary inherited properties
  const unnecessaryProps = ["inputType", "size", "maxLength", "autocomplete"];
  unnecessaryProps.forEach((propName) => {
    const prop = Serializer.findProperty(QUESTION_TYPE, propName);
    if (prop) {
      prop.visible = false;
    }
  });

  // Automatically set inputType to "date" (important!)
  const inputTypeProp = Serializer.findProperty(QUESTION_TYPE, "inputType");
  if (inputTypeProp) {
    inputTypeProp.defaultValue = "date";
    inputTypeProp.readOnly = true; // Prevent changing from date type
  }

  // Register with QuestionFactory
  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionEQ5D5LModel(name),
  );

  // Register React component
  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) =>
    React.createElement(SurveyQuestionEQ5D5L, props),
  );
}

// Auto-register
registerEQ5D5LQuestion();

export default QuestionEQ5D5LModel;
